import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import AdminDetails from './section-components/admin-details';
import Footer from './global-components/footer-v2';

const Administration = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Administration"  />
        <AdminDetails/>
        <Footer />
    </div>
}

export default Administration